module.exports = __webpack_public_path__ + "img/productos_nutraceuticos.066081d5.jpg";